import type { ParentComponent } from "solid-js";
import { Show, onMount } from "solid-js";
import {
  bootstrapAuth,
  useAuthReady,
  useOceanUser,
  useProvisionError,
  useUser,
} from "./stores/authStore";
import Shell from "./components/Shell";
import Login from "./routes/Login";

const App: ParentComponent = (props) => {
  const ready = useAuthReady();
  const user = useUser();
  const oceanUser = useOceanUser();
  const provisionError = useProvisionError();

  onMount(() => {
    bootstrapAuth().catch((e) => console.error("[auth] bootstrap failed", e));
  });

  return (
    <Show when={ready()} fallback={<div class="boot">Loading…</div>}>
      <Show when={user()} fallback={<Login />}>
        {(u) => (
          <Shell email={u().email} role={oceanUser()?.role ?? null}>
            <Show
              when={!provisionError()}
              fallback={
                <div class="banner error">
                  <strong>Profile not loaded:</strong> {provisionError()}
                  <div class="muted small">
                    Backend rejected the WorkOS token. Either the user record
                    doesn't exist in <code>users</code> (invite first) or
                    ocean-sync is missing <code>WORKOS_CLIENT_ID</code>.
                  </div>
                </div>
              }
            >
              {props.children}
            </Show>
          </Shell>
        )}
      </Show>
    </Show>
  );
};

export default App;
